<template>
  <div>
    <loading :active="$store.state.setLoading" :can-cancel="false" :is-full-page="true"></loading>
    <v-snackbar :value="$store.state.alert.show" top right :timeout="-1" :content-class="$store.state.alert.type">
      {{ $store.state.alert.message }}
    </v-snackbar>
    <router-view></router-view>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'App',
  components: {
    Loading
  }
};
</script>
<style>
.success {
  background-color: green;
}

.error {
  background-color: red;
}

.warning {
  background-color: yellow;
}
.v-btn {
    text-transform: unset !important;
}
</style>